/**
 * Point d'entrée UNIQUE vers `web-commun/connexion-google` (bouton, retour OAuth, contrôle d'accès) pour la supervision.
 *
 * ⚠️ Console d'ÉQUIPE : « Continuer avec Google » ne CRÉE jamais d'accès. Il se rattache à un compte DÉJÀ existant de même
 * e-mail vérifié ; ensuite `verifierAcces` (api/session.ts) exige `is_platform_admin()` et déconnecte sinon.
 * Voir `SwiftDeliver/docs/GOOGLE-CONSOLES.md`.
 */
import { creerConnexionGoogle, sessionViaGoogle } from '../../../../../web-commun/connexion-google'
import { CLE_PUBLISHABLE, URL_SUPABASE, supabase } from './supabase'

export { BoutonGoogle, erreurDeRetourOAuth } from '../../../../../web-commun/connexion-google'

export const connexionGoogle = creerConnexionGoogle({ client: supabase, url: URL_SUPABASE, cle: CLE_PUBLISHABLE })

/** La session en cours a-t-elle été ouverte par Google ? (lue dans le jeton : vraie aussi après un rechargement) */
export async function sessionOuverteParGoogle(): Promise<boolean> {
  const { data } = await supabase.auth.getSession()
  return sessionViaGoogle(data.session)
}
